import {OptionItem} from "../types";
import {apiRequest} from "../utils/AxiosHelper";
import APIs from "../modules/settings/APIs";
import {useAppSelector} from "./hooks";
import {useQuery} from '@tanstack/react-query';
import {API_PARAMS, ISSUE_TYPES, PAGINATION, STATUS_PARAMS} from "../constants/constants";


interface OptionsParams {
  propertyFind?: string;
  valueFind?: string;
  propertyOrder?: string;
  start?: number;
  limit?: number;
}

const fetchFilters = async (params: OptionsParams): Promise<Map<string, OptionItem[]>> => {
  const response = await apiRequest.get(APIs.filter.issues.create, {
    params: {
      start: params.start || 0,
      limit: params.limit || PAGINATION.DEFAULT_PAGE_LIMIT,
      propertyFindOption: params.propertyFind || 'f.identified',
      valueFindOption: params.valueFind || 'ISSUE',
      propertyOrderOption: params.propertyOrder || 'f.idFore',
      entityName: API_PARAMS.IMPACT.ISSUES_ENTITY,
      state: API_PARAMS.IS_ACTIVE,
      propertyFindStatus: STATUS_PARAMS.PROPERTY_FIND,
      valueFindStatus: ISSUE_TYPES.OPERATIONAL_RISK,
      propertyOrderStatus: STATUS_PARAMS.PROPERTY_ORDER,
    }
  });

  // Convert the response data to a proper Map
  const data = response.data;
  const optionsMap = new Map<string, OptionItem[]>();

  // If data is an object, convert its properties to Map entries
  if (data && typeof data === 'object') {
    Object.entries(data).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        optionsMap.set(key, value as OptionItem[]);
      } else if (data.options && typeof data.options === 'object') {
        Object.entries(data.options).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            optionsMap.set(key, value as OptionItem[]);
          }
        });
      }
    });
  }

  return optionsMap;
};

export const useCreateFilters = (params: OptionsParams = {}) => {
  const {isAuthenticated, token} = useAppSelector((state) => state.session);

  return useQuery({
    queryKey: ['options'],
    queryFn: () => fetchFilters(params),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    enabled: isAuthenticated && !!token // Only fetch when the user is authenticated
  });
};
